import { createContext } from "react";

const oportunityContext = createContext();

export default oportunityContext;
